var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Chip, Box } from '@mui/material';
import { Close } from '../../icons';
import colors from '../../colors';
import tinyColor from 'tinycolor2';
import { IconByName } from '../../utils/IconByName';
var getSize = function (size) {
    switch (size) {
        case 'tiny':
            return 'small';
        case 'medium':
        case 'small':
        default:
            return size;
    }
};
var ProductionDot = function () { return (_jsx("span", __assign({ id: "production-dot", style: {
        color: colors.mint[500],
        fontSize: '12px',
    } }, { children: "\u25CF" }))); };
var Tag = function (_a) {
    var onDelete = _a.onDelete, _b = _a.color, color = _b === void 0 ? colors.grey[100] : _b, label = _a.label, textTheme = _a.textTheme, size = _a.size, startIconName = _a.startIconName, withProductionDot = _a.withProductionDot, iconColor = _a.iconColor;
    if (!textTheme || textTheme === 'default') {
        textTheme = tinyColor(color).isDark() ? 'light' : 'dark';
    }
    var textColor = textTheme === 'dark' ? colors.grey[900] : colors.white;
    return (_jsx(Chip, { "data-testid": "sweep-tag", label: label ? (_jsxs(Box, __assign({ display: "flex", alignItems: "center", gap: 1 }, { children: [_jsx(Box, __assign({ sx: {
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    } }, { children: label })), withProductionDot && _jsx(ProductionDot, {})] }))) : undefined, size: getSize(size), className: size === 'tiny' ? 'chip-sizeTiny' : '', onDelete: onDelete, deleteIcon: onDelete ? _jsx(Close, { variant: "default", color: textColor }) : undefined, icon: startIconName ? (_jsx(IconByName, { name: startIconName, color: iconColor !== null && iconColor !== void 0 ? iconColor : textColor })) : undefined, sx: {
            background: color,
            '&.MuiChip-sizeSmall.chip-sizeTiny': {
                height: '16px',
                padding: '0 2px',
            },
            '.MuiChip-label': {
                color: textColor,
            },
        } }));
};
export default Tag;
